import { render, staticRenderFns } from "./LoginApproval.vue?vue&type=template&id=28ec3aec"
import script from "./LoginApproval.vue?vue&type=script&lang=js"
export * from "./LoginApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ec3aec')) {
      api.createRecord('28ec3aec', component.options)
    } else {
      api.reload('28ec3aec', component.options)
    }
    module.hot.accept("./LoginApproval.vue?vue&type=template&id=28ec3aec", function () {
      api.rerender('28ec3aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/LoginApproval.vue"
export default component.exports